"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var vite_exports = {};
__export(vite_exports, {
  SSRCSSPlugin: () => import_SSRCSSPlugin.SSRCSSPlugin,
  autoWarmPlugin: () => import_warmRoutesPlugin.autoWarmPlugin,
  build: () => import_build.build,
  clientTreeShakePlugin: () => import_clientTreeShakePlugin.clientTreeShakePlugin,
  createFileSystemRouterPlugin: () => import_fileSystemRouterPlugin.createFileSystemRouterPlugin,
  makePluginWebOnly: () => import_makePluginWebOnly.makePluginWebOnly,
  one: () => import_one.one,
  removeReactNativeWebAnimatedPlugin: () => import_removeReactNativeWebAnimatedPlugin.removeReactNativeWebAnimatedPlugin,
  resolvePath: () => import_resolve.resolvePath
});
module.exports = __toCommonJS(vite_exports);
var import_setupServerGlobals = require("./server/setupServerGlobals");
var import_resolve = require("@vxrn/resolve");
var import_build = require("./cli/build");
var import_makePluginWebOnly = require("./vite/makePluginWebOnly");
var import_one = require("./vite/one");
var import_clientTreeShakePlugin = require("./vite/plugins/clientTreeShakePlugin");
var import_fileSystemRouterPlugin = require("./vite/plugins/fileSystemRouterPlugin");
var import_removeReactNativeWebAnimatedPlugin = require("./vite/plugins/removeReactNativeWebAnimatedPlugin");
var import_SSRCSSPlugin = require("./vite/plugins/SSRCSSPlugin");
var import_warmRoutesPlugin = require("./vite/plugins/warmRoutesPlugin");
//# sourceMappingURL=vite.js.map
